import React, { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'

import { styled, Typography } from '@mui/material'
import { array, object } from 'prop-types'
import Dater from '../../services/DateFormat'

const StyleDiv = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: '1.3rem',
  justifyContent: 'center',
  height: '100%',
  color: theme.palette.primary.main
}))

const PeriodoSubtitle = styled(Typography)(({ theme }) => ({
  fontSize: '0.8rem',
  color: theme.palette.text.secondary,
  textAlign: 'center',
  marginBottom: '0.25rem'
}))

const Donutchart = ({ postagens = [], filters }) => {
  const [series, setSeries] = useState([])
  const [labels, setLabels] = useState([])
  const [periodoLabel, setPeriodoLabel] = useState('')

  useEffect(() => {
    init()
  }, [postagens])

  useEffect(() => {
    if (!filters) return
    const meses = Dater().meses
    const nomeMes = filters.mes_id
      ? meses.find(m => m.mes === filters.mes_id)?.nome
      : null
    const ano = filters.ano_id || new Date().getFullYear()
    setPeriodoLabel(nomeMes ? `${nomeMes}/${ano}` : `${ano}`)
  }, [filters])

  async function init() {
    setSeries(postagens)
    setLabels(['Texto', 'Video'])
  }

  const options = {
    labels,
    legend: {
      position: 'bottom',
      color: 'red',
      fontSize: '15px'
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: false
          }
        }
      }
    }
  }

  return (
    <div
      style={{
        height: '86%'
      }}
    >
      {periodoLabel && (
        <PeriodoSubtitle>{`Período: ${periodoLabel}`}</PeriodoSubtitle>
      )}
      {series.length > 0 && (
        <Chart
          style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            marginTop: '6%'
          }}
          type="donut"
          options={options}
          series={series}
          height="95%"
        />
      )}
      {series.length === 0 && <StyleDiv>(Não há dados para exibir)</StyleDiv>}
    </div>
  )
}

Donutchart.propTypes = {
  postagens: array,
  filters: object
}
export default Donutchart
